import React, { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useSelector } from 'react-redux';
import SummaryBreadcrumb from '@components/summary-panel/SummaryContainer/SummaryBreadcrumb';
import { getFirstAppliedFilter } from '@store/common/selectors';
import { drillDownListAtom, list4BreadcrumbAtom } from './utils/atom';
import { ConfigProvider } from 'antd';

function Header() {
  const setDrilldownList = useSetAtom(drillDownListAtom);
  const list4Breadcrumb = useAtomValue(list4BreadcrumbAtom);
  const appliedFilter = useSelector(getFirstAppliedFilter);
  const handleBreadcrumbClick = useCallback(
    (key: number) => {
      setDrilldownList(list4Breadcrumb.slice(0, key));
    },
    [list4Breadcrumb, setDrilldownList],
  );
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Breadcrumb: {
            colorTextDescription: '#0046ff',
            colorText: '#0046ff',
          },
        },
      }}
    >
      <div>
        <SummaryBreadcrumb
          drilldown={[appliedFilter, ...list4Breadcrumb] as any}
          applyFilterFromBreadcrumb={handleBreadcrumbClick}
        />
      </div>
    </ConfigProvider>
  );
}
export default Header;
